import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetAllPR_TypeOfActivity = createAsyncThunk(
  "dropdowns/GetAllPR_TypeOfActivity",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllPR_TypeOfActivity"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PR_TypeOfActivityDropDown = createSlice({
  name: "PR_TypeOfActivityDropDown",
  initialState: {
    PR_TypeOfActivityDropDown: [],
    loadingPR_TypeOfActivityDropDown: false,
    errorPR_TypeOfActivityDropDown: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPR_TypeOfActivity.pending, (state, action) => {
        state.loadingPR_TypeOfActivityDropDown = true;
        state.PR_TypeOfActivityDropDown = action.payload;
        state.errorPR_TypeOfActivityDropDown = null;
      })
      .addCase(GetAllPR_TypeOfActivity.fulfilled, (state, action) => {
        state.loadingPR_TypeOfActivityDropDown = false;
        state.PR_TypeOfActivityDropDown = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllPR_TypeOfActivity.rejected, (state, action) => {
        state.loadingPR_TypeOfActivityDropDown = false;
        state.errorPR_TypeOfActivityDropDown = action.payload;
      });
  },
});

export default PR_TypeOfActivityDropDown.reducer;
